module.exports = __webpack_public_path__ + "static/img/1.534e32d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/1.jpg
// module id = 3+nz
// module chunks = 1